import MobileIconUi from 'client/components/core/Sidebar/components/Settings/styles/ui/MobileIconUi'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import {
  OptionSingleValueType,
  SelectNew,
} from 'src/editor/shared/ui-lib/select-new/select-new'
import { useUpdateProp } from '../hooks/useUpdateProps'
import HtmlAttrId from '../options/HtmlAttrId'
import FlexAlignStyle from '../styles/FlexAlignStyle'

const captchaThemeChoices = [
  {
    label: 'light',
    value: 'light',
  },
  {
    label: 'dark',
    value: 'dark',
  },
]

const getCaptchaThemeOption = (theme: string) => {
  const currentCaptchaTheme = captchaThemeChoices.find(
    captchaTheme => captchaTheme.label === theme,
  )
  if (currentCaptchaTheme) {
    return currentCaptchaTheme
    // biome-ignore lint/style/noUselessElse: <explanation>
  } else return captchaThemeChoices[0]
}

function RecaptchaSettings({
  entity,
  defaultEntity,
}: {
  entity: RecaptchaInterface
  defaultEntity?: RecaptchaInterface
}) {
  const { isMobile } = useDeviceModeContext()
  const updateProp = useUpdateProp(entity)
  function updateCaptchaTheme(option: OptionSingleValueType) {
    if (option) {
      const update = updateProp('theme')
      update(option.value)
    }
  }
  return (
    <>
      <GroupTitle isFirst>settings_options.captcha.help_message</GroupTitle>
      <FlexAlignStyle
        align={entity.alignSelf}
        mobileAlign={entity.mobileAlignSelf}
        update={updateProp('alignSelf')}
        mobileUpdate={updateProp('mobileAlignSelf')}
      />
      <SelectNew
        labelText="captcha theme"
        options={captchaThemeChoices}
        selectedOption={
          entity.theme
            ? getCaptchaThemeOption(entity.theme)
            : captchaThemeChoices[0]
        }
        labelIcon={isMobile ? <MobileIconUi /> : undefined}
        onChange={updateCaptchaTheme}
        isMulti={false}
      />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default RecaptchaSettings
